/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Projects_Sidebar_All_FavoritesInputs */



/**
* | output |
* | --- |
* | "All favorites ({count})" |
*
* @param {Projects_Sidebar_All_FavoritesInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const projects_sidebar_all_favorites = /** @type {((inputs: Projects_Sidebar_All_FavoritesInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Projects_Sidebar_All_FavoritesInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Alle Favoriten (${i?.count})`)
	return /** @type {LocalizedString} */ (`All favorites (${i?.count})`)
});